/**
 * 404 admin zóny — s jednou výjimkou (KAN-1372).
 *
 * Když je první segment neznámé admin cesty slugem NAINSTALOVANÉ aplikace,
 * vede cesta na hostitele té aplikace. Funkce, která se z jádra
 * přestěhovala do aplikace pod týmž slugem (nesting), si tak zachová staré
 * záložky (``/admin/nesting``, ``/admin/nesting/42``) — a shell přitom
 * žádnou aplikaci nejmenuje. Tenant bez instalace dostane 404 jako dřív.
 */

import type { ReactNode } from "react";
import { Navigate, useParams } from "react-router-dom";

import { useInstalledApps } from "@/api/queries/admin/apps";

export function AdminFallbackRoute({
  children,
}: {
  children: ReactNode;
}): JSX.Element | null {
  const { lang = "cs", "*": rest = "" } = useParams<{
    lang?: string;
    "*"?: string;
  }>();
  const slug = rest.split("/")[0] ?? "";
  const installed = useInstalledApps(slug !== "");
  if (slug !== "" && installed.isLoading) return null;
  const app = (installed.data?.items ?? []).find((a) => a.slug === slug);
  if (app) {
    return (
      <Navigate to={`/${lang}/admin/apps/${encodeURIComponent(app.slug)}`} replace />
    );
  }
  return <>{children}</>;
}
